<template>
  <v-container class="wrapper">
    <div>
      <p class="sub-title">{{ $t('ESTIMATE_REPAIRER_OFFER.SUB_TITLE') }}</p>
      <button
        v-if="checkRepairFileEndStatusListNotNull()"
        :disabled="showRepairerOptionForm"
        class="button-content"
        @click="showRepairerOptionForm = true"
      >
        <img
          alt="cross round svg"
          :class="showRepairerOptionForm ? 'cross-round-disabled' : 'cross-round'"
          src="@/assets/icons/file/cross_round.svg"
        />
        <p class="button-text" :class="{ 'button-text-disabled': showRepairerOptionForm }">
          {{ $t('ESTIMATE_REPAIRER_OFFER.BUTTON.ADD_FORM') }}
        </p>
        <img
          alt="arrow right svg"
          :class="showRepairerOptionForm ? 'arrow-right-disabled' : 'arrow-right'"
          src="@/assets/icons/file/arrow_right.svg"
        />
      </button>

      <!--FORM OPTION-->
      <v-col cols="12" v-if="showRepairerOptionForm">
        <v-form
          ref="formEstimateRepairerOption"
          v-model="formEstimateRepairerOptionIsValid"
          @submit.prevent="addEstimateRepairerOption"
        >
          <v-row class="card-content">
            <v-col cols="12">
              <p>{{ $t('ESTIMATE_REPAIRER_OFFER.TITLE_FORM') }}</p>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                id="select"
                v-model="repairFileEndStatusSelected"
                :items="repairFileEndStatusList"
                :placeholder="$t('ESTIMATE_REPAIRER_OFFER.PLACEHOLDER.OFFER_TYPE')"
                item-title="name"
                item-value="technical_id"
                required
                hide-details
                bg-color="white"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip size="small" v-if="index < 1">
                    <span>{{ item.title }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="text-grey text-caption align-self-center">
                    ({{ repairFileEndStatusSelected.length - 1 }}
                    {{
                      repairFileEndStatusSelected.length - 1 === 1
                        ? $t('COMMON.TABLE.OTHER')
                        : $t('COMMON.TABLE.OTHERS')
                    }})
                  </span>
                </template>
                <template v-slot:item="{ item, props }">
                  <v-list-item :title="item.title" :value="item.value" v-bind="props">
                    <v-tooltip
                      v-if="shouldShowTooltip(item, 'select')"
                      activator="parent"
                      location="bottom left"
                    >
                      {{ item.title }}
                    </v-tooltip>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model.trim="comment"
                :placeholder="$t('ESTIMATE_REPAIRER_OFFER.PLACEHOLDER.COMMENT')"
                :rules="requiredRules"
                auto-grow
                rows="1"
                :hide-details="!commentIsFocused"
                :maxlength="500"
                :counter="commentIsFocused"
                @update:focused="commentIsFocused = $event"
                bg-color="white"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="estimateCost"
                :placeholder="$t('ESTIMATE_REPAIRER_OFFER.PLACEHOLDER.ESTIMATE_COST')"
                type="number"
                :rules="[...requiredRules, ...numberRules]"
                hide-details="auto"
                bg-color="white"
              >
                <template #append-inner>
                  <p class="text-disabled price-content">
                    {{ $t('COMMON.EURO') }}
                  </p>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="transportCost"
                :placeholder="$t('ESTIMATE_REPAIRER_OFFER.PLACEHOLDER.TRANSPORT_COST')"
                type="number"
                :rules="numberRules"
                hide-details="auto"
                bg-color="white"
              >
                <template #append-inner>
                  <p class="text-disabled price-content">
                    {{ $t('COMMON.EURO') }}
                  </p>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" v-if="repairFileEndStatusSelected === 'PRODUCT_REPAIRED'">
              <v-text-field
                v-model="laborCost"
                :placeholder="$t('ESTIMATE_REPAIRER_OFFER.PLACEHOLDER.LABOR_COST')"
                type="number"
                :rules="numberRules"
                hide-details="auto"
                bg-color="white"
              >
                <template #append-inner>
                  <p class="text-disabled price-content">
                    {{ $t('COMMON.EURO') }}
                  </p>
                </template>
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn
                class="boom-button w-100"
                :disabled="
                  !formEstimateRepairerOptionIsValid ||
                  loading ||
                  repairFileEndStatusSelected === null
                "
                @click="addEstimateRepairerOption"
                :loading="loading"
                variant="outlined"
              >
                <template v-slot:prepend>
                  <img
                    alt="cross round svg"
                    :class="
                      !formEstimateRepairerOptionIsValid || repairFileEndStatusSelected === null
                        ? 'cross-round-green'
                        : 'cross-round-white'
                    "
                    src="@/assets/icons/file/cross_round.svg"
                  />
                </template>
                {{ $t('COMMON.BUTTON.VALIDATE') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>

      <v-row>
        <v-col
          v-for="repairer_estimate_option of currentRepairFile?.repairer_estimate
            ?.repairer_estimate_option_list"
          :key="repairer_estimate_option.id"
          cols="12"
        >
          <div class="offer-content">
            <div class="d-flex align-center justify-space-between w-100">
              <p class="offer-title">
                {{
                  $t(
                    'COMMON.PRODUCT_END_STATUS.' + repairer_estimate_option.offer_type.toUpperCase()
                  )
                }}
              </p>
              <p
                class="offer-title"
                v-if="!visiblePriceInputField.includes(repairer_estimate_option.technical_id)"
              >
                {{ Number(repairer_estimate_option.total_cost).toFixed(2) }} {{ $t('COMMON.EURO') }}
              </p>
            </div>
            <div class="d-flex align-center justify-space-between w-100">
              <p class="offer-text">
                {{
                  repairer_estimate_option.offer_type === 'PRODUCT_REPAIRED'
                    ? $t('ESTIMATE_REPAIRER_OFFER.LABOR_COST')
                    : $t('ESTIMATE_REPAIRER_OFFER.TRANSPORT_COST')
                }}
              </p>
              <p class="offer-text">
                {{
                  (
                    repairer_estimate_option.estimate_cost +
                    repairer_estimate_option.transport_cost +
                    repairer_estimate_option.labor_cost
                  ).toFixed(2)
                }}
                {{ $t('COMMON.EURO') }}
              </p>
            </div>
            <div class="line-content" />
            <div class="d-flex align-center justify-space-between w-100">
              <p class="offer-text">{{ $t('ESTIMATE_REPAIRER_OFFER.MARGIN') }}</p>
              <p
                class="offer-text"
                v-if="!visibleMarginInputField.includes(repairer_estimate_option.technical_id)"
              >
                {{ repairer_estimate_option.margin }} {{ $t('COMMON.PERCENT') }}
              </p>
            </div>
            <div class="d-flex align-center justify-space-between ga-2 w-100">
              <div class="d-flex align-center justify-start ga-2 flex-fill">
                <!--- PRICE UPDATE --->
                <v-btn
                  class="boom-button add-boom-button pl-5 pr-5"
                  variant="outlined"
                  v-if="
                    !visibleMarginInputField.includes(repairer_estimate_option.technical_id) &&
                    !visiblePriceInputField.includes(repairer_estimate_option.technical_id)
                  "
                  @click="togglePriceTextField(repairer_estimate_option.technical_id)"
                >
                  {{ $t('ESTIMATE_REPAIRER_OFFER.MODIFICATION_PRICE') }}
                </v-btn>
                <v-form
                  ref="formUpdateEstimateRepairerOption"
                  v-model="formUpdateEstimateRepairerOptionIsValid"
                  @submit.prevent="updateRepairerEstimateOption"
                  class="d-flex align-center justify-space-between w-100 mt-6"
                  v-if="
                    visiblePriceInputField.includes(repairer_estimate_option.technical_id) &&
                    !visibleMarginInputField.includes(repairer_estimate_option.technical_id)
                  "
                >
                  <div class="margin-input">
                    <v-text-field
                      reverse
                      v-model="repairer_estimate_option.total_cost"
                      type="number"
                      :rules="numberRules"
                      hide-details
                    >
                      <template v-slot:prepend-inner>
                        <v-btn
                          class="boom-button pl-5 pr-5 h-100"
                          :disabled="!formUpdateEstimateRepairerOptionIsValid || loading"
                          @click="
                            updateRepairerEstimateOption(repairer_estimate_option, 'totalCost')
                          "
                        >
                          {{ $t('ESTIMATE_REPAIRER_OFFER.SAVE_PRICE') }}
                        </v-btn>
                      </template>
                    </v-text-field>
                  </div>
                </v-form>

                <!--- MARGIN UPDATE --->
                <v-btn
                  class="boom-button add-boom-button pl-5 pr-5"
                  variant="outlined"
                  v-if="
                    !visibleMarginInputField.includes(repairer_estimate_option.technical_id) &&
                    !visiblePriceInputField.includes(repairer_estimate_option.technical_id)
                  "
                  @click="toggleMarginTextField(repairer_estimate_option.technical_id)"
                >
                  {{ $t('ESTIMATE_REPAIRER_OFFER.MODIFICATION_MARGIN') }}
                </v-btn>
                <v-form
                  ref="formUpdateEstimateRepairerOption"
                  v-model="formUpdateEstimateRepairerOptionIsValid"
                  @submit.prevent="updateRepairerEstimateOption"
                  class="d-flex align-center justify-space-between w-100 mt-6"
                  v-if="
                    visibleMarginInputField.includes(repairer_estimate_option.technical_id) &&
                    !visiblePriceInputField.includes(repairer_estimate_option.technical_id)
                  "
                >
                  <div class="margin-input">
                    <v-text-field
                      reverse
                      v-model="repairer_estimate_option.margin"
                      type="number"
                      :rules="marginRules"
                      hide-details
                    >
                      <template v-slot:prepend-inner>
                        <v-btn
                          class="boom-button pl-5 pr-5 h-100"
                          :disabled="!formUpdateEstimateRepairerOptionIsValid || loading"
                          @click="updateRepairerEstimateOption(repairer_estimate_option, 'margin')"
                        >
                          {{ $t('ESTIMATE_REPAIRER_OFFER.SAVE_MARGIN') }}
                        </v-btn>
                      </template>
                    </v-text-field>
                  </div>
                </v-form>
              </div>

              <button
                v-if="
                  !visibleMarginInputField.includes(repairer_estimate_option.technical_id) &&
                  !visiblePriceInputField.includes(repairer_estimate_option.technical_id)
                "
                @click="deleteRepairerEstimateOption(repairer_estimate_option)"
              >
                <v-icon class="delete-icon" icon="mdi-delete" />
              </button>
            </div>
          </div>
        </v-col>
      </v-row>
      <div
        v-if="currentRepairFile?.repairer_estimate?.repairer_estimate_option_list.length > 0"
        class="ml-2"
      >
        {{ $t('ESTIMATE_REPAIRER_OFFER.INFO_CLIENT') }}
      </div>
    </div>

    <div class="bottom-content">
      <v-col cols="12" class="px-0">
        <v-btn
          class="boom-button w-100"
          :disabled="
            loading ||
            currentRepairFile?.repairer_estimate?.repairer_estimate_option_list.length === 0
          "
          :loading="loading"
          variant="outlined"
          @click="submit"
        >
          {{ $t('COMMON.BUTTON.SAVE') }}
        </v-btn>
      </v-col>
      <v-btn
        class="button w-100"
        :loading="loading"
        variant="outlined"
        @click="$emit('cancelEstimateRepairer')"
      >
        {{ $t('COMMON.BUTTON.CANCEL') }}
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import RepairFileService from '@/services/RepairFileService'
import { auth as $store } from '@/store/AuthModule'
import RepairFileEndStatusConstant from '@/constants/repairFileEndStatusConstant'
import { handleResponseError, shouldShowTooltip } from '@/components/utils/globalFunction'
import Validator from '@/components/utils/validator'

export default {
  props: {
    currentRepairFile: Object
  },
  data() {
    return {
      loading: false,
      formEstimateRepairerOptionIsValid: false,
      formUpdateEstimateRepairerOptionIsValid: false,
      showRepairerOptionForm: false,

      repairFileEndStatusList: [],
      repairFileEndStatusSelected: null,
      comment: null,
      commentIsFocused: false,
      estimateCost: null,
      transportCost: null,
      laborCost: null,
      totalCost: null,
      baseMargin: 25,
      visiblePriceInputField: [],
      visibleMarginInputField: [],

      requiredRules: Validator.requiredRules,
      numberRules: Validator.numberRules,
      marginRules: Validator.marginRules
    }
  },
  created() {
    //Remove already selected status
    this.patchRepairFileEndStatusList()
    this.showRepairerOptionForm = this.checkRepairFileEndStatusListNotNull()
    if (this.currentRepairFile?.repairer_estimate?.repairer_estimate_option_list.length !== 0) {
      this.showRepairerOptionForm = false
    }
  },
  watch: {
    currentRepairFile() {
      this.patchRepairFileEndStatusList()
      if (this.currentRepairFile?.repairer_estimate?.repairer_estimate_option_list.length === 0) {
        this.showRepairerOptionForm = true
      }
    },
    showRepairerOptionForm() {
      this.patchRepairFileEndStatusList()
    }
  },
  methods: {
    shouldShowTooltip,
    toggleMarginTextField(id) {
      if (this.visibleMarginInputField.includes(id)) {
        this.visibleMarginInputField = this.visibleMarginInputField.filter(
          (visibleId) => visibleId !== id
        )
      } else {
        this.visibleMarginInputField.push(id)
      }
    },
    togglePriceTextField(id) {
      if (this.visiblePriceInputField.includes(id)) {
        this.visiblePriceInputField = this.visiblePriceInputField.filter(
          (visibleId) => visibleId !== id
        )
      } else {
        this.visiblePriceInputField.push(id)
      }
    },
    checkRepairFileEndStatusListNotNull() {
      return this.repairFileEndStatusList.length !== 0
    },
    patchRepairFileEndStatusList() {
      // Create a list of repair file end statuses
      this.repairFileEndStatusList = Object.keys(RepairFileEndStatusConstant).map((key) => ({
        technical_id: key,
        name: this.$t(
          `REPAIR_FILE_DELIVERY_CLIENT_DRAWER.PRODUCT_END_STATUS.${RepairFileEndStatusConstant[key]}`
        )
      }))
      // Filter the list to exclude statuses already present in repairer estimate options
      this.repairFileEndStatusList = this.repairFileEndStatusList.filter((status) => {
        return !this.currentRepairFile?.repairer_estimate?.repairer_estimate_option_list.some(
          (option) => option.offer_type.toUpperCase() === status.technical_id
        )
      })
    },
    async addEstimateRepairerOption() {
      this.loading = true

      this.calculateBaseTotalCost()

      try {
        const data = {
          requestor_collaborator_id: this.getCurrentCollaborator().technical_id,
          repair_file_id: this.currentRepairFile.technical_id,
          repairer_estimate_id: this.currentRepairFile.repairer_estimate.technical_id,
          offer_type: this.repairFileEndStatusSelected,
          comment: this.comment,
          margin: this.baseMargin,
          estimate_cost: this.estimateCost,
          transport_cost: this.transportCost || 0,
          labor_cost: this.laborCost || 0,
          total_cost: this.totalCost
        }
        await RepairFileService.createRepairFileRepairerEstimateOption(data)
        this.$emit('updateCurrentRepairFile')
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
        this.showRepairerOptionForm = false
        this.repairFileEndStatusSelected = null
        this.comment = null
        this.estimateCost = null
        this.transportCost = null
        this.laborCost = null
        this.totalCost = null
        this.patchRepairFileEndStatusList()
      }
    },
    async updateRepairerEstimateOption(repairerEstimateOption, type) {
      this.loading = true

      if (type === 'totalCost') {
        this.calculateNewMargin(repairerEstimateOption)
      } else if (type === 'margin') {
        this.calculateNewTotalCost(repairerEstimateOption)
      }

      try {
        const data = {
          requestor_collaborator_id: this.getCurrentCollaborator().technical_id,
          repair_file_id: this.currentRepairFile.technical_id,
          repairer_estimate_id: this.currentRepairFile.repairer_estimate.technical_id,
          repairer_estimate_option_id: repairerEstimateOption.technical_id,
          offer_type: repairerEstimateOption.offer_type,
          comment: repairerEstimateOption.comment,
          margin: Number(repairerEstimateOption.margin),
          estimate_cost: repairerEstimateOption.estimate_cost,
          transport_cost: repairerEstimateOption.transport_cost || 0,
          labor_cost: repairerEstimateOption.labor_cost || 0,
          total_cost: Number(repairerEstimateOption.total_cost)
        }
        await RepairFileService.updateRepairFileRepairerEstimateOption(data)
        this.$emit('updateCurrentRepairFile')
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async deleteRepairerEstimateOption(repairerEstimateOption) {
      this.loading = true
      try {
        const data = {
          requestor_collaborator_id: this.getCurrentCollaborator().technical_id,
          repair_file_id: this.currentRepairFile.technical_id,
          repairer_estimate_option_id: repairerEstimateOption.technical_id
        }
        await RepairFileService.deleteRepairFileRepairerEstimateOption(data)
        this.$emit('updateCurrentRepairFile')
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async submit() {
      this.loading = true
      try {
        const data = {
          requestor_collaborator_id: this.getCurrentCollaborator().technical_id,
          repair_file_id: this.currentRepairFile.technical_id
        }
        await RepairFileService.confirmationRepairFileRepairerEstimate(data)
        this.$emit('updateCurrentRepairFile')
        this.$emit('openEstimateRepairerDetail')
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
        this.patchRepairFileEndStatusList()
      }
    },
    getCurrentCollaborator() {
      return $store.state.currentCollaborator
    },
    calculateBaseTotalCost() {
      this.totalCost =
        (Number(this.estimateCost) + Number(this.transportCost) + Number(this.laborCost)) /
        (1 - this.baseMargin / 100)
    },
    calculateNewMargin(repairerEstimateOption) {
      const newMargin =
        (100 *
          (repairerEstimateOption.total_cost -
            (repairerEstimateOption.estimate_cost +
              repairerEstimateOption.transport_cost +
              repairerEstimateOption.labor_cost))) /
        repairerEstimateOption.total_cost
      repairerEstimateOption.margin = Number(newMargin.toFixed(0))
      this.togglePriceTextField(repairerEstimateOption.technical_id)
    },
    calculateNewTotalCost(repairerEstimateOption) {
      const newTotalCost =
        (repairerEstimateOption.estimate_cost +
          repairerEstimateOption.transport_cost +
          repairerEstimateOption.labor_cost) /
        (1 - repairerEstimateOption.margin / 100)
      repairerEstimateOption.total_cost = parseFloat(newTotalCost)
      this.toggleMarginTextField(repairerEstimateOption.technical_id)
    }
  }
}
</script>

<style scoped>
.card-content {
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 20px;
  background: #efefef;
  margin-bottom: 20px;
}

.sub-title {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 20px;
}

.button-content {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.button-text-disabled {
  color: #acacac !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  margin-right: 10px;
}

.button-text {
  color: #559a1b;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  margin-right: 10px;
}

.boom-button {
  padding: 10px 20px !important;
}

:deep(.v-infinite-scroll__side) {
  padding: unset;
}

.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.bottom-content {
  margin-top: auto;
}

.button {
  width: 35%;
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  text-transform: none !important;
  border-radius: 20px;
  border: 1px solid #000;
  background: #fff;
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.button:disabled {
  background: #efefef;
  color: #000;
}

.price-content {
  margin-left: 10px;
  font-size: 20px;
}

.cross-round-disabled {
  height: 14px;
  width: 14px;
  margin-right: 10px;
  filter: invert(69%) sepia(11%) saturate(14%) hue-rotate(326deg) brightness(98%) contrast(89%);
}

.arrow-right-disabled {
  height: 14px;
  width: 14px;
  filter: invert(69%) sepia(11%) saturate(14%) hue-rotate(326deg) brightness(98%) contrast(89%);
}

.arrow-right {
  height: 14px;
  width: 14px;
  filter: invert(58%) sepia(37%) saturate(5700%) hue-rotate(58deg) brightness(91%) contrast(79%);
}

.cross-round {
  height: 14px;
  width: 14px;
  margin-right: 10px;
  filter: invert(58%) sepia(37%) saturate(5700%) hue-rotate(58deg) brightness(91%) contrast(79%);
}

.cross-round-white {
  height: 14px;
  width: 14px;
  filter: invert(100%) sepia(0%) saturate(2%) hue-rotate(327deg) brightness(108%) contrast(101%);
}

.cross-round-green {
  height: 14px;
  width: 14px;
  filter: invert(47%) sepia(77%) saturate(455%) hue-rotate(50deg) brightness(93%) contrast(92%);
}

.offer-content {
  border-radius: 20px;
  border: 1px solid #559a1b;
  display: flex;
  padding: 20px;

  flex-direction: column;
  align-items: flex-start;
  gap: 10px;

  align-self: stretch;
}

.offer-title {
  font-size: 16px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.offer-text {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
}

.line-content {
  width: 100%;
  border-top: 1px solid black;
}

.margin-input {
  width: 100%;
}

.add-boom-button {
  margin-top: 10px;
}

:deep(.v-field--prepended) {
  padding-left: 0 !important;
}

.delete-icon {
  height: 36px;
  margin-top: 10px;
}
</style>
